import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=71ec0b12&"
import script from "./Attributes.vue?vue&type=script&lang=js&"
export * from "./Attributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports